import $ from 'cash-dom';

export default () => {
  const $links = $('.js-switcher-item');

  $links.each((i, el) => {
    const $this = $(el);
    const sectionName = $this.attr('href');
    const $section = $(sectionName);
    const topSection = $section.offset().top;
    const sectionHeight = $section.outerHeight();
    const windowHeight = $(window).height();

    $(window).on('scroll', () => {
      const scrollTop = window.pageYOffset;

      if (scrollTop >= topSection - (windowHeight / 3)
        && scrollTop <= topSection + sectionHeight - (windowHeight / 3)) {
        $this.addClass('is-active');
      } else {
        $this.removeClass('is-active');
      }
    });
  });
};
